<template>
  <el-dialog title="身份验证" :visible.sync="dialogVisible" width="30%" @close="closeFn()"
             :close-on-click-modal="closeClickModal">
    <div class="dialog_conwrap dialog_auth" v-if="!pageStatus">
      <p>手机号修改需要进行身份验证,请根据指示完成验证</p>
      <p>验证码发送至:{{form.phone}}</p>
      <p>
        <label class="w100">验证码：</label>
        <el-input class="w160" type="text" placeholder="输入验证码" v-model="oldPhoneCode"></el-input>
        <el-button @click="btnPhoneCode(0)" class="btnPhoneCode" v-if="btndisabled">{{codeWord}}</el-button>
        <el-button disabled v-else class="btnPhoneCode">{{codeWord}}</el-button>
      </p>
    </div>
    <div class="dialog_conwrap dialog_auth" v-else>
      <div v-if="editType==1">
        <p class="first-line">
          <label class="w100">绑定新手机：</label>
          <el-input class="w160" type="text" placeholder="输入手机号码" v-model="newForm.phone"></el-input>
        </p>
        <p>
          <label class="w100">验证码：</label>
          <el-input class="w160" type="text" placeholder="输入验证码" v-model="newForm.code"></el-input>
          <el-button @click="btnPhoneCode(1)" class="btnPhoneCode" v-if="btndisabled">{{codeWord}}</el-button>
          <el-button disabled v-else class="btnPhoneCode">{{codeWord}}</el-button>
        </p>
      </div>
      <div v-else>
        <p class="first-line">
          <label class="w100">登入账号：</label>
          <el-input class="w160" type="text" placeholder="输入新登入账号" v-model="username"></el-input>
        </p>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false" v-if="pageStatus" size="small">取 消</el-button>
      <el-button type="primary" @click="nextCheck" size="small">{{checkword}}</el-button>
    </span>
  </el-dialog>
</template>
<script>
  // 身份验证,用于修改手机，或者修改账号信息
  // editType 1 修改手机； 2 修改账户信息
  import api from '@/api.js'
  export default {
    name: "enterpriseAuthPhoneDialog",
    props: ["visible", "formData", "editType"],
    watch: {
      formData: {
        immediate: true,
        handler(val) {
          this.form = val
        }
      },
      visible() {
        this.dialogVisible = this.visible;
      }
    },
    mounted() {
      // props 是单向数据流，通过触发 update 事件绑定 formData，
      // 将 data 里的 form 指向父组件通过 formData 绑定的那个对象
      // 父组件在绑定 formData 的时候，需要加上 .sync
      this.$emit('update:formData', this.form)
    },
    data() {
      return {
        closeClickModal: false,
        dialogVisible: this.visible,
        pageStatus: false,
        checkword: '下一步',
        oldPhoneCode: '',
        newForm: {
          phone: '',
          code: ''
        },
        // 验证码
        allTime: 60,
        codeWord: '发送验证码',
        btndisabled: true,
        flag: true,
        username: null
      };
    },
    created() {
      this.form = this.formData
    },
    methods: {
      btnPhoneCode(option) {
        //  option 0 旧电话验证码 1 新电话验证码
        if (this.flag) {
          // type 发送类型(0企业手机号、1新手机号)  phone  	手机号(当type为0时无需传)
          let data_ = {}
          if (option === 0) {
            data_.type = 0
          } else {
            data_.type = 1
            data_.phone = this.newForm.phone
          }
          this.axios
              .post(api.companyadmin_send_code, data_)
              .then(response => {
                if (response.data.code == 0) {
                  this.flag = false
                  this.btndisabled = false
                  this.getCode()
                } 
              })
              .catch(response => {
              });
        }
      },
      getCode() {
        // codeWord: '发送验证码'
        let self_ = this
        this.btndisabled = false
        this.codeWord = '60s'
        this.setInter = setInterval(
            function () {
              let numVal = self_.allTime - 1;
              let codeText = numVal + 's'
              if (numVal <= 0) {
                codeText = '重新获取验证码';
                numVal = 60;
                self_.codeWord = '重新获取'
                self_.flag = true
                self_.btndisabled = true
                clearInterval(self_.setInter)
              }
              ;
              self_.allTime = numVal
              self_.codeWord = codeText
            }, 1000);
      },
      nextCheck() {
        let self_ = this
        if (this.checkword === '下一步') {
          if (this.oldPhoneCode) {
            // 验证
            this.axios
                .post(api.companyadmin_check_code, {code: this.oldPhoneCode})
                .then(response => {
                  if (response.data.code == 0) {
                    clearInterval(self_.setInter)
                    this.allTime = 60
                    this.codeWord = '发送验证码'
                    this.pageStatus = true
                    this.checkword = '确定'
                    this.oldPhoneCode = ''
                  } 
                })
                .catch(response => {
                });
          } else {
            this.$message({
              message: '请填写短信验证码',
              type: 'warning'
            });
          }
        } else {
          // editType 1 修改手机； 2 修改账户信息
          if (this.editType === 1) {
            if (!this.newForm.phone) {
              this.$message({
                message: '请输入绑定的新手机',
                type: 'warning'
              });
              return
            }
            if (!this.newForm.code) {
              this.$message({
                message: '请输入验证码',
                type: 'warning'
              });
              return
            }
            this.axios
                .post(api.companyadmin_edit_phone, {code: this.newForm.code, phone: this.newForm.phone})
                .then(response => {
                  if (response.data.code == 0) {
                    this.$message({
                      message: '编辑成功',
                    });
                    this.$emit('initPage')
                    this.dialogVisible = false
                  } 
                })
                .catch(response => {
                });
          }else{
            // username: null
            if (!this.username) {
              this.$message({
                message: '请输入新账号',
                type: 'warning'
              });
              return
            }
            this.axios
                .post(api.companyadmin_edit_username, {username: this.username})
                .then(response => {
                  if (response.data.code == 0) {
                    this.$message({
                      message: '编辑成功',
                    });
                    this.$emit('initPage')
                    this.dialogVisible = false
                  } 
                })
                .catch(response => {
                });
          }
        }
      },
      closeFn() {
        clearInterval(this.setInter)
        this.allTime = 60
        this.codeWord = '发送验证码'
        this.$emit('update:visible', false);
      }
    }
  };
</script>
<style>
  .btnPhoneCode {
    margin-left: 10px;
  }

  .first-line {
    margin-bottom: 10px;
  }
</style>

